/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalAssistant from './hospital-assistant';
import HospitalAssistantDetail from './hospital-assistant-detail';
import HospitalAssistantUpdate from './hospital-assistant-update';
import HospitalAssistantDeleteDialog from './hospital-assistant-delete-dialog';

const HospitalAssistantRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalAssistant />} />
    <Route path="new" element={<HospitalAssistantUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalAssistantDetail />} />
      <Route path="edit" element={<HospitalAssistantUpdate />} />
      <Route path="delete" element={<HospitalAssistantDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalAssistantRoutes;
